export default (image) => {
    return image.childImageSharp ? image.childImageSharp.fluid.src : image
}
